import type {
  BatteryMeasurement,
  LocationMeasurement,
  TemperatureMeasurement,
} from 'graphql-models';
import { randomId, type Factory } from 'walden-fast/types/mocks';

const MOCK_TEMPERATURE_MEASUREMENT: TemperatureMeasurement = {
  id: '1',
  measuredAt: new Date().toISOString(),
  valueCelsius: 20,
};

const MOCK_LOCATION_MEASUREMENT: LocationMeasurement = {
  id: '1',
  measuredAt: new Date().toISOString(),
  latitude: 0,
  longitude: 0,
};

const MOCK_BATTERY_MEASUREMENT: BatteryMeasurement = {
  id: '1',
  measuredAt: new Date().toISOString(),
  percent: 77,
};

export const temperatureMeasurementFactory: Factory<TemperatureMeasurement> = (
  overrides,
) => ({
  ...MOCK_TEMPERATURE_MEASUREMENT,
  id: randomId(),
  ...overrides,
});

export const locationMeasurementFactory: Factory<LocationMeasurement> = (
  overrides,
) => ({
  ...MOCK_LOCATION_MEASUREMENT,
  id: randomId(),
  ...overrides,
});

export const batteryMeasurementFactory: Factory<BatteryMeasurement> = (
  overrides,
) => ({
  ...MOCK_BATTERY_MEASUREMENT,
  id: randomId(),
  ...overrides,
});
